import React, { useState } from 'react';
import { translate } from '../../Services/translation';

const MyPagesImageStorage = ({ imageStoragePageUrl }) => {
    const [errorMessage, setErrorMessage] = useState("");

    const openImageStorageLink = (e) => {
        e.preventDefault();
        if (imageStoragePageUrl !== "") {
            window.location.href = imageStoragePageUrl;
        }
        else {
            setErrorMessage(translate('mypage.image.storage.error'));
        }
    };

    return (
        <div className="col-span-2">
            <h1 className="mb-2">{translate('mypage.image.storage.title')}</h1>
            <p className="mb-4 max-w-3xl text-lg lg:mb-6">
                {translate('mypage.image.storage.description')}
            </p>

            {errorMessage && <p className="error">{errorMessage}</p>}

            <button
                className="btn btn--large btn--primary mt-2 lg:mt-4"
                onClick={openImageStorageLink}
            >
                {translate('form.image.storage.open')}
            </button>
        </div>
    );
};

export default MyPagesImageStorage;
